<template>
  <div class="card flex-grow-1 mb-4">
    <div class="card-header d-flex py-1">
      <strong class="pt-1">Resources</strong>
      <button class="btn btn-link ml-auto py-0" type="button" data-toggle="collapse" data-target="#resource-links"><i
          class="fas fa-chevron-circle-up"></i></button>
    </div>
    <div id="resource-links" class="card-body collapse">
      <div class="card">
        <div class="card-header">Resource Links</div>
        <div class="card-body">
          <div v-if="resourceLinks.length > 0" class="row">
            <div class="col-md-5">Resource URL</div>
            <div class="col-md-5">Resource Label</div>
          </div>
          <div v-for="(resource, index) in resourceLinks" :key="index" class="row mb-2">
            <div class="col-md-5">
              <input type="text" v-model="resource.url" class="w-100 form-control">
            </div>
            <div class="col-md-5">
              <input type="text" v-model="resource.label" class="w-100 form-control">
            </div>
            <div class="col-md-2">
              <button type="button" v-on:click.prevent="removeResourceLink(index)" class="btn btn-danger">Remove
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <button type="button" v-on:click.prevent="addResourceLink()" class="btn btn-primary">Add Resource</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-0">
        <div class="card-header">Page Drawers</div>
        <div class="card-body" ref="drawerList">
          <div class="row">
            <div class="col-10">
              <page-selector :id-index="'drawer-page-lookup'" :api-url="apiUrl" @handle-change="selected = $event"
                             class="mb-3"></page-selector>
            </div>
            <div class="col-2 d-flex align-items-center">
              <button type="button" v-on:click.prevent="addDrawer()" class="btn btn-primary">Add Drawer</button>
            </div>
          </div>
          <div
              v-for="(drawer, index) in drawerPages"
              :key="drawer.pageId || index"
              class="row mb-2 align-items-center"
          >
            <div class="col-1 d-flex flex-column align-items-center justify-content-center">
              <button class="btn btn-link p-0" type="button" :disabled="index === 0" @click="moveDrawerUp(index)">
                <i class="fas fa-arrow-up"></i>
              </button>
              <button class="btn btn-link p-0" type="button" :disabled="index === drawerPages.length - 1"
                      @click="moveDrawerDown(index)">
                <i class="fas fa-arrow-down"></i>
              </button>
            </div>
            <div class="col-9 d-flex align-items-center">
              {{ drawer.name }}
            </div>
            <div class="col-2 d-flex align-items-center">
              <button type="button" class="btn btn-default mr-2" @click="openDrawerModal(index)">
                <i class="fas fa-cog"></i>
              </button>
              <button type="button" v-on:click.prevent="removeDrawer(index)" class="btn btn-danger">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Drawer Edit Modal -->
  <div class="modal fade" id="drawerEditModal" tabindex="-1" role="dialog" aria-labelledby="drawerEditModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="drawerEditModalLabel">
            Edit Drawer
            <span v-if="modalDrawer.name">: {{ modalDrawer.name }}</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="drawer-label">Label</label>
            <input id="drawer-label" type="text" v-model="modalDrawer.label" class="form-control">
          </div>
          <div class="form-group">
            <label for="drawer-bkgcolor">Background Color (hex)</label>
            <div class="d-flex">
              <div style="height: auto; width: 10%; border: 1px solid #ced4da; border-right: none;"
                   :style="{'background-color': modalDrawer.bkgColor}"></div>
              <input id="drawer-bkgcolor" type="text" v-model="modalDrawer.bkgColor" class="form-control">
            </div>
          </div>
          <div class="form-group">
            <label for="drawer-txtcolor">Text Color (hex)</label>
            <div class="d-flex">
              <div style="height: auto; width: 10%; border: 1px solid #ced4da; border-right: none;"
                   :style="{'background-color': modalDrawer.txtColor}"></div>
              <input id="drawer-txtcolor" type="text" v-model="modalDrawer.txtColor" class="form-control">
            </div>
          </div>
          <div class="form-group">
            <label for="drawer-icon">Icon</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <a class="btn btn-primary text-white" data-input="drawer-icon-input" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input id="drawer-icon-input" type="text" v-model="modalDrawer.icon" class="form-control">
            </div>
          </div>
          <div class="form-group">
            <label for="drawer-align">Alignment</label>
            <select v-model="modalDrawer.align" id="drawer-align" class="form-control">
              <option value="right">Right</option>
              <option value="left">Left</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="saveDrawerEdit">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageSelector from '../components/PageSelector.vue'

export default {
  props: ['resources', 'drawers', 'isVersion'],
  components: {
    PageSelector
  },
  data() {
    return {
      resourceLinks: [],
      drawerPages: [],
      selected: null,
      editingDrawerIndex: null,
      modalDrawer: {label: '', bkgColor: '', txtColor: '', icon: '', align: 'right'}
    }
  },
  computed: {
    apiUrl: function () {
      return this.isVersion ? '/api/page/versions' : '/api/pages'
    }
  },
  methods: {
    addResourceLink: function () {
      this.resourceLinks.push({url: '', label: ''})
    },
    removeResourceLink: function (index) {
      this.resourceLinks.splice(index, 1)
    },
    getResources: function () {
      return this.resourceLinks
    },
    addDrawer: function () {
      this.drawerPages.push({
        pageId: this.selected.id,
        name: this.selected.text,
        label: '',
        bkgColor: '',
        txtColor: '',
        icon: ''
      })
    },
    removeDrawer: function (index) {
      this.drawerPages.splice(index, 1)
    },
    getDrawers: function () {
      return this.drawerPages
    },
    openDrawerModal(index) {
      this.editingDrawerIndex = index
      // Deep copy to avoid mutating before save
      this.modalDrawer = Object.assign({}, this.drawerPages[index])
      this.$nextTick(() => {
        // Initialize filemanager for the icon picker
        $(this.$el).find('[data-lfm="image"]').filemanager('image', {prefix: '/filemanager'})
      })
      $('#drawerEditModal').modal('show')
    },
    saveDrawerEdit() {
      if (this.editingDrawerIndex !== null) {
        // Update the drawer with modal values
        this.drawerPages[this.editingDrawerIndex].name = this.modalDrawer.name
        this.drawerPages[this.editingDrawerIndex].label = this.modalDrawer.label
        this.drawerPages[this.editingDrawerIndex].bkgColor = this.modalDrawer.bkgColor
        this.drawerPages[this.editingDrawerIndex].txtColor = this.modalDrawer.txtColor
        this.drawerPages[this.editingDrawerIndex].icon = this.modalDrawer.icon
        this.drawerPages[this.editingDrawerIndex].align = this.modalDrawer.align
      }
      $('#drawerEditModal').modal('hide');
    },
    moveDrawerUp(index) {
      if (index > 0) {
        const moved = this.drawerPages.splice(index, 1)[0]
        this.drawerPages.splice(index - 1, 0, moved)
      }
    },
    moveDrawerDown(index) {
      if (index < this.drawerPages.length - 1) {
        const moved = this.drawerPages.splice(index, 1)[0]
        this.drawerPages.splice(index + 1, 0, moved)
      }
    }
  },
  mounted() {
    //init resources
    this.resourceLinks = this.resources ?? []
    this.drawerPages = this.drawers ?? []
  }
}
</script>